export default [
  {
    path: '/sales/sales-submissions/changi',
    name: 'sales-changi-submissions',
    component: () => import('@/views/sales/changi-submission/SubmissionList.vue'),
    meta: {
      title: 'Sales Submissions (Changi)',
      pageTitle: 'Sales',
      breadcrumb: [
        {
          text: 'Sales Submissions (Changi)',
          active: true,
        },
      ],
      resource: 'ChangiSalesSubmission',
      action: 'read',
    },
  },
  {
    path: '/sales/sales-submissions/changi/:id/show',
    name: 'sales-changi-submissions-show',
    component: () => import('@/views/sales/changi-submission/SubmissionDetails.vue'),
    meta: {
      title: 'Submission Detail',
      pageTitle: 'Sales',
      navActiveLink: 'sales-changi-submissions',
      breadcrumb: [
        {
          text: 'Sales Submissions (Changi)',
          to: '/sales/sales-submissions/changi',
        },
        {
          text: 'Submission Detail',
          active: true,
        },
      ],
      resource: 'ChangiSalesSubmission',
      action: 'show',
    },
  },
]
